var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"home-actions"},[_c('button',{staticClass:"home-button",on:{"click":_vm.goToQuery}},[_vm._v("扫码查重")]),_c('button',{staticClass:"home-button",on:{"click":_vm.goToQueryByHand}},[_vm._v("手工查重")]),_c('button',{staticClass:"home-button",on:{"click":_vm.goToExport}},[_vm._v("报销记录")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }